export const actionTypes: any = {
  // Get ATM Data
  GET_ATM_DATA_START: 'GET_ATM_DATA_START',
  GET_ATM_DATA_SUCCESS: 'GET_ATM_DATA_SUCCESS',
  GET_ATM_DATA_FINISH: 'GET_ATM_DATA_FINISH',

  // add ATM
  ADD_ATM_START: 'ADD_ATM_START',
  ADD_ATM_SUCCESS: 'ADD_ATM_SUCCESS',
  ADD_ATM_FINISH: 'ADD_ATM_FINISH',
  RESET_ATM: 'RESET_ATM',

  // update branch
  UPDATE_ATM_START: 'UPDATE_ATM_START',
  UPDATE_ATM_SUCCESS: 'UPDATE_ATM_SUCCESS',
  UPDATE_ATM_FINISH: 'UPDATE_ATM_FINISH',

  // delete branch
  DELETE_ATM_START: 'DELETE_ATM_START',
  DELETE_ATM_SUCCESS: 'DELETE_ATM_SUCCESS',
  DELETE_ATM_FINISH: 'DELETE_ATM_FINISH',

  // Import branch
  IMPORT_ATM_START: 'IMPORT_ATM_START',
  IMPORT_ATM_SUCCESS: 'IMPORT_ATM_SUCCESS',
  IMPORT_ATM_FINISH: 'IMPORT_ATM_FINISH',

  // Enable Branch
  ENABLE_ATM_REQUEST: 'ENABLE_ATM_REQUEST',
  ENABLE_ATM_SUCCESS: 'ENABLE_ATM_SUCCESS',
  ENABLE_ATM_FINISH: 'ENABLE_ATM_FINISH',

  // Disable Branch
  DISABLE_ATM_REQUEST: 'DISABLE_ATM_REQUEST',
  DISABLE_ATM_SUCCESS: 'DISABLE_ATM_SUCCESS',
  DISABLE_ATM_FINISH: 'DISABLE_ATM_FINISH',

  // Enable Branch
  SINGLE_ENABLE_ATM_REQUEST: 'SINGLE_ENABLE_ATM_REQUEST',
  SINGLE_ENABLE_ATM_SUCCESS: 'SINGLE_ENABLE_ATM_SUCCESS',
  SINGLE_ENABLE_ATM_FINISH: 'SINGLE_ENABLE_ATM_FINISH',

  // Disable Branch
  SINGLE_DISABLE_ATM_REQUEST: 'SINGLE_DISABLE_ATM_REQUEST',
  SINGLE_DISABLE_ATM_SUCCESS: 'SINGLE_DISABLE_ATM_SUCCESS',
  SINGLE_DISABLE_ATM_FINISH: 'SINGLE_DISABLE_ATM_FINISH',

  // get File csv xlsx
  EXPORT_ATM_FILE_START: 'EXPORT_ATM_FILE_START',
  EXPORT_ATM_FILE_SUCCESS: 'EXPORT_ATM_FILE_SUCCESS',
  EXPORT_ATM_FILE_FINISH: 'EXPORT_ATM_FILE_FINISH',

  EXPORT_ATM_TEMPLATE_FILE_START: 'EXPORT_ATM_TEMPLATE_FILE_START',
  EXPORT_ATM_TEMPLATE_FILE_SUCCESS: 'EXPORT_ATM_TEMPLATE_FILE_SUCCESS',
  EXPORT_ATM_TEMPLATE_FILE_FINISH: 'EXPORT_ATM_TEMPLATE_FILE_FINISH',
}
